import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Toaster } from 'sonner';
import { TooltipProvider } from 'src/components/ui/tooltip';
import { useTheme } from './contexts/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import AdminLayout from './components/admin/AdminLayout';
import Login from './pages/Login';

const ThemedToaster = () => {
  const { resolved } = useTheme();
  return (
    <Toaster
      theme={resolved}
      position="top-center"
      closeButton
      toastOptions={{
        classNames: {
          success: 'toast-success',
          error: 'toast-error',
          warning: 'toast-warning',
          info: 'toast-info',
          loading: 'toast-loading',
          closeButton: 'toast-close-button',
        },
      }}
    />
  );
};

const App = () => (
  <TooltipProvider delayDuration={200}>
    <Switch>
      <PrivateRoute path="/app" component={AdminLayout} />
      <Route path="/signin" component={Login} />
      <Redirect exact from="/" to="/app/dashboard" />
      <Redirect to="/signin" />
    </Switch>
    <ThemedToaster />
  </TooltipProvider>
);

export default App;
